export default "__VITE_ASSET__DgkQFuf4__"